import { config } from 'config';
import { GeneralApiTagTypes } from 'core/api';
import { attachmentsApi } from 'core/attachments/api';

import { TMailAttachmentFileRequestBody, TMailAttachmentFileResponseBody } from '../types';

const updateAttachmentApi = attachmentsApi.injectEndpoints({
    endpoints: (builder) => ({
        mailAttachmentFile: builder.mutation<TMailAttachmentFileResponseBody, TMailAttachmentFileRequestBody>({
            query: ({ attachmentId, emails, message, language }) => {
                return {
                    url: config.api.endpoints.attachments.mailAttachment.replace(':id', attachmentId.toString()),
                    method: 'POST',
                    body: {
                        emails,
                        message,
                        lang: language,
                    },
                };
            },
            invalidatesTags: (_res, _error, _args) => [
                { type: GeneralApiTagTypes.attachment.item },
                { type: GeneralApiTagTypes.attachment.list },
                { type: GeneralApiTagTypes.invoice.list },
                { type: GeneralApiTagTypes.commission.list },
            ],
        }),
    }),
});

export const { useMailAttachmentFileMutation } = updateAttachmentApi;
